"use client"
import {
  Input
} from "./chunk-YYT6SG4M.mjs";

// src/components/file-input.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var FileInput = mergeMultiStyle(Input)();

export {
  FileInput
};
//# sourceMappingURL=chunk-NSM437IM.mjs.map